<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddCliente"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Nuevo Cliente</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="false">&times;</span>
            </button>
          </div>
          <form @submit="guardarCliente">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.nit,
                      }"
                      >NIT</label
                    >
                    <div class="input-group">
                      <input
                        v-model="current.nit"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="NIT"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.nit,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.nit"
                        class="form-text text-danger"
                        >{{ current.errors.nit[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.nombre,
                    }"
                    >Nombre</label
                  >
                  <div class="input-group">
                    <input
                      v-model="current.nombre"
                      class="form-control"
                      placeholder="Nombre"
                      v-bind:class="{
                        'is-invalid': current.errors && current.errors.nombre,
                      }"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.nombre"
                      class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.direccion,
                    }"
                    >Dirección</label
                  >
                  <div class="input-group">
                    <textarea
                      v-model="current.direccion"
                      class="form-control"
                      placeholder="Dirección"
                      autofocus="autofocus"
                      v-bind:class="{
                        'is-invalid':
                          current.errors && current.errors.direccion,
                      }"
                      type="text"
                    ></textarea>
                    <small
                      v-if="current.errors && current.errors.direccion"
                      class="form-text text-danger"
                      >{{ current.errors.direccion[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-12">
                  <label for>Email</label>
                  <div class="input-group">
                    <input
                      v-model="current.email"
                      class="form-control"
                      placeholder="Email"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.email"
                      class="form-text text-danger"
                      >{{ current.errors.email[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Agregar</button>
              <button
                class="btn btn-secondary"
                ref="cerrarModalCliente"
                data-dismiss="modal"
                type="button"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <a
      class="btn btn-sm btn-success"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
      data-backdrop="static"
      data-keyboard="false"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Nueva Cotización</span>
    </a>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Nueva Cotización</h5>
            <button class="close" type="button" @click="cerrarModalPedido">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="crearPedido">
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.tienda &&
                          current.errors.tienda.length > 0,
                      }"
                      >Tienda</label
                    >
                    <div class="input-group">
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        required
                        v-model="current.tienda"
                        @input="$emit('input', $event.target.value)"
                        @change="refreshCajas()"
                      >
                        <option
                          v-for="(tienda, key) in tiendas"
                          :value="tienda.codigo"
                          :key="key"
                        >
                          {{ tienda.nombre }}
                        </option>
                      </select>
                    </div>
                    <small
                      v-if="current.errors && current.errors.tienda"
                      class="form-text text-danger"
                    >
                      {{ current.errors.tienda[0] }}
                    </small>
                  </div>
                </div>
                <div v-if="current.tienda && cajas" class="col-sm-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.caja,
                      }"
                      >Cajas</label
                    >
                    <div class="input-group">
                      <select
                        class="form-control"
                        required
                        v-model="current.caja"
                        :disabled="current.tienda == null"
                      >
                        <option
                          v-for="(caja, key) in cajas"
                          :value="caja.id"
                          :key="key"
                        >
                          {{ caja.caja }} -
                          <span v-if="caja.esta_abierta == true">
                            Caja Abierta: Si</span
                          >
                          <span v-if="caja.esta_abierta == false">
                            Caja Abierta: No</span
                          >
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.caja"
                        class="form-text text-danger"
                        >{{ current.errors.caja[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div v-if="current.tienda" class="col-sm-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.tipo_pago &&
                          current.errors.tipo_pago.length > 0,
                      }"
                      >Tipo de Pago</label
                    >
                    <div class="input-group">
                      <select
                        class="form-control"
                        v-model="current.tipo_pago"
                        required
                      >
                        <option value="CONTADO">Contado</option>
                        <option value="CREDITO">Crédito</option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tipo_pago"
                        class="form-text text-danger"
                        >{{ current.errors.tipo_pago[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div
                  v-if="current.tienda && current.caja"
                  class="col-sm-12 col-md-12"
                >
                  <ClientesSelectComponent :current="current" />
                </div>
                <div
                  v-if="current.tienda && current.caja && current.cliente_nit"
                  class="col-sm-12"
                >
                  <div class="form-group">
                    <label for>Nombre del Cliente</label>
                    <div class="input-group">
                      <input
                        id="cliente_nombre"
                        disabled
                        ref="cliente_nombre"
                        v-model="current.cliente_nit.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="current.tienda && current.caja && current.cliente_nit"
                  class="col-sm-12"
                >
                  <div class="form-group">
                    <label for>Dirección</label>
                    <div class="input-group">
                      <input
                        id="cliente_direccion"
                        disabled
                        ref="cliente_direccion"
                        v-model="current.cliente_nit.direccion"
                        class="form-control"
                        placeholder="Dirección"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="current.tienda && current.caja && current.cliente_nit"
                  class="col-sm-12"
                >
                  <div class="form-group">
                    <label for>Correo Electrónico</label>
                    <div class="input-group">
                      <input
                        id="email"
                        disabled
                        v-model="current.cliente_nit.email"
                        ref="email"
                        class="form-control"
                        placeholder="Correo Electrónico"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Agregar</button>
              <button
                class="btn btn-secondary"
                @click="cerrarModalPedido"
                type="button"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import CajaService from "@/services/cxc/CajaService";
import ClienteService from "@/services/catalogos/ClienteService";
import Notifications from "@/notifications/notifications";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import { mapGetters } from "vuex";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";

export default {
  components: {
    UnidadMedidaSelectComponent,
    TiendaSelectComponent,
    ClientesSelectComponent,
  },
  data() {
    return {
      cajas: [],
      cliente: {
        nit: null,
        email: "",
      },
      current: {
        cliente_nit: "",
        cliente_nombre: "",
        cliente_direccion: "",
        tipo_pago: null,
        tienda: null,
        caja: null,
        tipo_pago: "CONTADO",
        lista_precio: null,
        estado: "A",
        errors: {
          nombre: [],
        },
      },
    };
  },
  props: ["lista_precio", "producto"],
  watch: {},
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      clientes: "catalogos/clientes",
    }),
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
  },
  mounted() {
    let self = this;
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
  },
  methods: {
    cerrarModalPedido() {
      $("#modalAddProductoPrecio").find("input,textarea,select").val("");
      $("#modalAddProductoPrecio").modal("hide");
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    refreshCajas() {
      let self = this;
      this.current.caja = "";
      CajaService.fetch({
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.cajas = res.data;
      });
    },

    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),

    crearPedido(e) {
      let self = this;
      e.preventDefault();
      if (self.current.cliente_nit) {
        self.current.cliente_nombre = self.current.cliente_nit.nombre;
        self.current.cliente_direccion = self.current.cliente_nit.direccion;
        self.current.cliente_nit = self.current.cliente_nit.nit;
      }
      if (!self.current.cliente_nit) {
        Notifications.alert.confirm(
          "Cliente no válido",
          "¿Desea agregar nuevo cliente?",
          "Si",
          function () {
            $("#modalAddProductoPrecio").modal("hide");
            $("#modalAddCliente").modal();
          }
        );
      }
      var _current = Object.assign({}, this.current);
      PedidosServices.save(_current)
        .then((res) => {
          self.current.errors = {};
          Notifications.alert.success(
            "Cotización",
            "Se ha agregado nuevo pedido"
          );
          self.$router.push({
            name: "pos-cotizaciones-editar",
            params: { id: res.data.id },
          });
          $("#modalAddProductoPrecio").modal("hide");
          $("#modalAddCliente").modal("hide");
        })
        .catch((error) => {
          console.log(error.response.data);
          self.current.errors = Object.assign({}, error.response.data);
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            if ("detail" in error.response.data) {
              Notifications.alert.error("Error", error.response.data.detail);
            }
          });
        });
    },
    guardarCliente(e) {
      e.preventDefault();
      let self = this;
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      ClienteService.save(current)
        .then((res) => {
          self.current.cliente_nit = res.data;
          self.current.errors = {};
          Notifications.alert.confirm(
            "Cliente Agregado exitosamente",
            "¿Desea continuar el pedido?",
            "Si",
            function () {
              self.$refs.cerrarModalCliente.click();
              $("#modalAddProductoPrecio").modal();
            }
          );
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Ups :(", error.response.data.nit[0]);
          }
        });
    },
  },
};
</script>
